<template>
    <div class="bottom-number">
            <p>{{name}}</p>
            <p v-if="show_support">平台支持:血管资讯</p>
       		<p v-show="type==1">沪ICP备11005620号-15</p>
		    <p v-show="type==2">沪ICP备11005620号-95</p>
    </div>
</template>
<script>
export default {
    props:{
        name:String,
        meeting_id:String,
        show_support:Number
    },
      data(){
        return{
           realName:'',
           type:1
        }
    },
    mounted(){
        this.realmName=window.location.host;
        if(this.realName.indexOf('xgzx.talkmed.com')>-1){
            this.type=1;
        }
        if(this.realName.indexOf('vascularnews.cn')>-1){
            this.type=2;
        }

    }
}
</script>
<style lang="scss" scoped>
.bottom-number{
    margin: 10px;
    color: #b5b5b5;
    font-size: 12px;
    text-align: center;
    line-height: 16px;
    height: 60px;
}

</style>>


// WEBPACK FOOTER //
// src/pages/VascularSystem/Meeting/Bottom.vue